<template>
  <div>
    <span 
      v-if="type=='button'"
    >
      <v-icon
        color="blue darken-2"
        :disabled="document.estatus.descripcion != 'Firmado'"
        @click="onClick"
        >{{ 
          format === 'pdf' ? icon.pdf : icon.xml 
        }}</v-icon
      >
    </span>
    <v-list-item
      v-else-if="type=='list'"
      :disabled="document.estatus.descripcion != 'Firmado'"
      @click="onClick"
    >
      <v-list-item-title>{{format === 'pdf' ? 'Descarga PDF' : 'Descarga XML'}}</v-list-item-title>
    </v-list-item>
  </div>
</template>

<script>
import { mdiFilePdfBox, mdiFileXmlBox } from '@mdi/js'
import PscServices from '../../services/PscReportsService'
import { pushNotification, messageErrorResponse } from '@/store/helpers'

export default {
  name: 'DocumentConstancyDownload',
  props: {
    document: {
      type: Object,
      required: true
    },
    type: {
      type: String,
      default: 'button'
    },
    format: {
      type: String,
      default: 'pdf'
    }
  },
  data() {
    return {
      icon: {
        pdf: mdiFilePdfBox,
        xml: mdiFileXmlBox
      },
      loading: false
    }
  },
  methods: {
    onClick() {
      this.loading = true
      this.$emit('busy')

      const service = new PscServices()

      if(this.format == 'pdf'){
        service
          .downloadPdf(this.document.idDocumento)
          .then(result => {
            let blob = new Blob([result.data], {type: "application/pdf"})
            const contentDisposition = result.headers['content-disposition']
            let fileName = this.document.nombre
            if (contentDisposition) {
              const fileNameMatch = contentDisposition.match(/filename[^;=\n]*=(?:[^\s]+'.*?')?([^;\n]*)/i)
              if (fileNameMatch.length === 2) {fileName = fileNameMatch[1]}
            }
            let link = document.createElement('a')
            link.href = window.URL.createObjectURL(blob)
            link.download = fileName
            link.click()
          })
          .catch(() => {
            this.notificationError('No se pudo descargar el archivo')
          })
          .finally(()=>{
            this.loading = false
            this.$emit('unoccupied')
          })
      } else {
        service
          .downloadXml(this.document.idDocumento)
          .then(result => {
            if (result.data.successful.code == 'CONSTANCIES_XML_GET_200') {
              var link = document.createElement('a')
              link.href = result.data.data.presignedUrl
              link.download = this.document.nombre.replace('.pdf','')
              link.click()
            } else {
              this.notificationError(messageErrorResponse(result))
            }
          })
          .catch(err => {
            this.notificationError(messageErrorResponse(err))
          })
          .finally(()=>{
            this.loading = false
            this.$emit('unoccupied')
          })
      }
    },
    notificationError(msg) {
      pushNotification(
        this.$store,
        msg,
        'error',
        'left',
        false,
        false
      )
    }
  }
}
</script>